export default __webpack_public_path__ + "static/Expand-Collapse-Arrow-cc3a0cb9fd36e0ecb9ba022e33564c6e.svg";